import React from "react"

import { Input } from "@coval/ui"

import { FieldLabel } from "@/components/shared/forms/FieldLabel"

import { CHAT_WEBSOCKET_TOOLTIPS } from "./tooltips"
import type { ChatWebSocketFieldProps } from "./types"

export const BehaviorFields: React.FC<ChatWebSocketFieldProps> = ({
  metadata,
  onMetadataUpdate,
  disabled = false,
}) => {
  return (
    <div className="space-y-4">
      <h4 className="text-sm font-medium text-coval-text">Message Behavior</h4>

      {/* Initial Message */}
      <div className="space-y-2">
        <FieldLabel
          htmlFor="initial-message"
          tooltip={CHAT_WEBSOCKET_TOOLTIPS.initialMessage}
        >
          Initial Message
        </FieldLabel>
        <Input
          id="initial-message"
          aria-label="Initial Message"
          placeholder="Hello!"
          value={metadata.initial_message ?? ""}
          onChange={(e) =>
            onMetadataUpdate({ initial_message: e.target.value })
          }
          disabled={disabled}
        />
        <p className="text-xs text-coval-text-muted">
          First message sent to the agent after connection and handshake. Leave
          empty to skip.
        </p>
      </div>

      {/* Message Coalesce Timeout */}
      <div className="space-y-2">
        <FieldLabel
          htmlFor="coalesce-timeout"
          tooltip={CHAT_WEBSOCKET_TOOLTIPS.messageCoalesceTimeout}
        >
          Message Coalesce Timeout (seconds)
        </FieldLabel>
        <Input
          id="coalesce-timeout"
          aria-label="Message Coalesce Timeout"
          type="number"
          placeholder="2.0"
          min={0}
          step={0.1}
          value={
            metadata.message_coalesce_timeout_seconds != null
              ? String(metadata.message_coalesce_timeout_seconds)
              : ""
          }
          onChange={(e) => {
            const raw = e.target.value
            if (raw === "") {
              onMetadataUpdate({
                message_coalesce_timeout_seconds: undefined,
              })
            } else {
              const parsed = parseFloat(raw)
              if (!isNaN(parsed) && isFinite(parsed) && parsed >= 0) {
                onMetadataUpdate({
                  message_coalesce_timeout_seconds: parsed,
                })
              }
            }
          }}
          disabled={disabled}
        />
        <p className="text-xs text-coval-text-muted">
          Time in seconds to wait after the last received message before
          delivering the batch. Set to 0 for immediate delivery (default: 2.0).
        </p>
      </div>
    </div>
  )
}
